import { render } from "./QueuesInfo.vue?vue&type=template&id=5e5597f7"
import script from "./QueuesInfo.vue?vue&type=script&lang=js"
export * from "./QueuesInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__